<template lang="pug">
    div(
        :class="classes"
    )
        span
</template>

<script lang="ts">
import Vue, { computed, PropType, toRefs, useCssModule } from 'vue'

import { propsDefault } from '@/shared/lib/vue-utils/propsDefault'

import { TextProps } from './data'

export default Vue.extend({
    name: 'TheText',
    props: {
        tag: {
            type: String as PropType<TextProps['tag']>,
            default: 'p',
        },
        color: {
            type: String as PropType<TextProps['color']>,
            default: 'primary',
        },
        align: {
            type: String as PropType<TextProps['align']>,
        },
        name: {
            type: String as PropType<TextProps['name']>,
            default: 'captionRegular',
        },
        ...propsDefault,
    },
    setup(props) {
        const { name, color } = toRefs(props)

        const textStyles = useCssModule()

        const classes = computed(() => {
            return [
                textStyles[`font_${name.value}`],
                textStyles[`color_${color.value}`],
            ]
        })

        return {
            classes,
        }
    },
})
</script>

<style lang="scss" module src="./TheTextSkeleton.module.scss" />
